import React, { } from 'react'
import FormPNForAirport from '../ci/formPNForAirport';
import FormPNForTruck from '../ci/formPNForTruck';
import FormPNForChuyenKhau from '../ci/formPNForChuyenKhau';

export default function PaymentNoticeViewer(props) {
    switch (props.data.loadingtype_id) {
        case 0: //Chuyen khau
            return <FormPNForChuyenKhau {...props} />
        case 1: //airport
            return <FormPNForAirport {...props} />
        case 3: //truck
            return <FormPNForTruck {...props} />
        default:
            return `No form found for loadingtype id: ${props?.data?.loadingtype_id}`
    }
}